// import firebase from "./firebase"
// import GENRALHELPERS from "./GENRAL-HELPERS"

// import { PushNotifications } from '@capacitor/push-notifications';


// class CTANotifications {
//     #CTANotificationEventsInitialized = false

//     _CTANotificationsOn(hide) {
//         const CTAActivateNotifications = document.getElementById('CTAActivateNotifications')
//         const CTAActivateNotificationsButtonActivate = document.getElementById('CTAActivateNotificationsButtonActivate')
//         const CTAActivateNotificationsButtonClose = document.getElementById('CTAActivateNotificationsButtonClose')


//         if (!hide) {
//             CTAActivateNotifications.style.display = 'flex'
//         } else {
//             CTAActivateNotifications.style.display = 'none'
//         }


//         if (this.#CTANotificationEventsInitialized) return
//         this.#CTANotificationEventsInitialized = true
//         CTAActivateNotificationsButtonActivate.addEventListener('click', () => {
//             this._pushNotificationsActivate()
//             CTAActivateNotifications.style.display = 'none'
//         })
//         CTAActivateNotificationsButtonClose.addEventListener('click', () => {
//             CTAActivateNotifications.style.display = 'none'
//         })

//     }



//     async _pushNotificationsActivate() {
//         async function getSWRegistration() {
//             if (!("serviceWorker" in navigator)) {
//                 throw new Error("Service workers not supported");
//             }

//             // If already controlling → resolves immediately
//             if (navigator.serviceWorker.controller) {
//                 return navigator.serviceWorker.ready;
//             }

//             // Otherwise wait for control change
//             await new Promise((resolve) => {
//                 navigator.serviceWorker.addEventListener(
//                     "controllerchange",
//                     () => resolve(),
//                     { once: true }
//                 );
//             });

//             return navigator.serviceWorker.ready;
//         }

//         console.warn("before SW");
//         const swRegistration = await getSWRegistration();
//         console.warn("SW ready:", swRegistration);

//         const userData = firebase._getLatestCurrentUserData()

//         await firebase._getAndStoreFCMToken('userData.uid', swRegistration);
//     }


//     async _initializePushNotifications() {
//         const status = GENRALHELPERS._getPushNotificationStatus()

//         console.log(status)
//         if (status === 'permission needed') {
//             this._CTANotificationsOn()
//             return
//         }
//         if (status) {
//             this._pushNotificationsActivate()
//         }
//     }




//     // START Native notification
//     async _initNativePush() {
//         // Only run on native
//         if (!window.Capacitor?.isNativePlatform?.()) return;

//         // 🔐 Request permission
//         const permStatus = await PushNotifications.requestPermissions();

//         if (permStatus.receive !== 'granted') {
//             console.warn('Push permission not granted');
//             return;
//         }

//         // 📡 Register device
//         await PushNotifications.register();

//         // 🎟️ Token
//         PushNotifications.addListener('registration', (token) => {
//             console.log('📱 Native FCM Token:', token.value);

//             // 👉 Save SAME as web
//             firebase._savePushToken(token.value);
//         });

//         // ❌ Error
//         PushNotifications.addListener('registrationError', (err) => {
//             console.error('Push registration error:', err);
//         });

//         // 📩 Foreground notification
//         PushNotifications.addListener('pushNotificationReceived', (notification) => {
//             console.log('📩 Foreground push:', notification);
//         });

//         // 👆 User taps notification
//         PushNotifications.addListener('pushNotificationActionPerformed', (notification) => {
//             console.log('👆 Notification tapped:', notification);

//             const data = notification.notification.data;

//             if (data?.url) {
//                 openUrls._parseLocateAndDisplay(data.url);
//             }
//         });
//     }
//     // END Native notification

// }

// export default new CTANotifications()



import firebase from "./firebase"
import GENRALHELPERS from "./GENRAL-HELPERS"
import { PushNotifications } from '@capacitor/push-notifications';
import openUrls from "./open-app-urls/open-urls"; // adjust path if needed
import saved from "./saved-and-Followed/saved";
import nav from "./home-screen/nav";

import { App } from '@capacitor/app';

class CTANotifications {
    #CTANotificationEventsInitialized = false
    #nativeInitialized = false

    /* ================================
       🚀 ENTRY POINT
       ================================ */
    // async init() {
    //     // 👉 Always try native first
    //     await this._initNativePush();

    //     // 👉 Then handle web logic
    //     await this._initializePushNotifications();
    // }


    async init() {
        const isNative = window.Capacitor?.isNativePlatform?.();

        if (isNative) {
            document.addEventListener("deviceready", async () => {
                await this._initNativePush();
            }, { once: true });
        } else {
            await this._initializePushNotifications();
        }
    }


    _initNotificationClickListener() {

        const openNotification =
            localStorage.getItem('openNotification');

        if (openNotification) {

            console.log("🔔 Opening notifications from persisted flag");

            saved._openNotifications();
            nav._changeNav('Notification');
        }



        // setTimeout(() => {

        //     // 🚫 Prevent double handling
        //     if (window.__NOTIFICATION_HANDLED__) {
        //         console.warn("🚫 Notification already handled");
        //         return;
        //     }

        //     // 📩 Native notification tap
        //     if (window.__PENDING_NOTIFICATION__) {

        //         console.log("🟡 Handling delayed native notification");

        //         window.__NOTIFICATION_HANDLED__ = true;

        //         const notif = window.__PENDING_NOTIFICATION__;
        //         const data = notif.notification?.data || {};

        //         // 🔔 Only open notification panel if explicitly from push
        //         if (data.fromNotification === "true") {
        //             saved._openNotifications();
        //             nav._changeNav('Notification');
        //         }

        //         // 🔗 Handle route
        //         if (data.url) {
        //             openUrls._parseLocateAndDisplay(data.url);
        //         }

        //         // 🧹 Cleanup
        //         window.__PENDING_NOTIFICATION__ = null;
        //     }

        // }, 500);

        // if (!("serviceWorker" in navigator)) return;

        // navigator.serviceWorker.addEventListener("message", (event) => {
        //     const data = event.data;

        //     if (!data) return;

        //     // 🔔 Open notification panel
        //     if (data.type === "OPEN_NOTIFICATION_PANEL") {
        //         console.log("🔔 Notification click detected");

        //         saved._openNotifications();
        //         nav._changeNav('Notification');

        //         // optional: also navigate via URL if needed
        //         if (data.url) {
        //             openUrls._parseLocateAndDisplay(data.url);
        //         }
        //     }
        // });


        // App.addListener('appUrlOpen', (event) => {
        //     console.log('🚀 App opened from notification:', event);

        //     saved._openNotifications();
        //     nav._changeNav('Notification');

        //     if (event.url) {
        //         openUrls._parseLocateAndDisplay(event.url);
        //     }
        // });
    }

    /* ================================
       🌐 CTA UI (WEB)
       ================================ */
    _CTANotificationsOn(hide) {
        const CTAActivateNotifications = document.getElementById('CTAActivateNotifications')
        const CTAActivateNotificationsButtonActivate = document.getElementById('CTAActivateNotificationsButtonActivate')
        const CTAActivateNotificationsButtonClose = document.getElementById('CTAActivateNotificationsButtonClose')

        if (!hide) {
            CTAActivateNotifications.style.display = 'flex'
        } else {
            CTAActivateNotifications.style.display = 'none'
        }

        if (this.#CTANotificationEventsInitialized) return
        this.#CTANotificationEventsInitialized = true

        CTAActivateNotificationsButtonActivate.addEventListener('click', () => {
            this._pushNotificationsActivate()
            CTAActivateNotifications.style.display = 'none'
        })

        CTAActivateNotificationsButtonClose.addEventListener('click', () => {
            CTAActivateNotifications.style.display = 'none'
        })
    }

    /* ================================
       🌐 WEB PUSH
       ================================ */
    async _pushNotificationsActivate() {
        async function getSWRegistration() {
            if (!("serviceWorker" in navigator)) {
                throw new Error("Service workers not supported");
            }

            if (navigator.serviceWorker.controller) {
                return navigator.serviceWorker.ready;
            }

            await new Promise((resolve) => {
                navigator.serviceWorker.addEventListener(
                    "controllerchange",
                    () => resolve(),
                    { once: true }
                );
            });

            return navigator.serviceWorker.ready;
        }

        console.warn("🌐 Web push flow");

        const swRegistration = await getSWRegistration();

        const userData = firebase._getLatestCurrentUserData()

        // ⚠️ FIXED BUG HERE
        await firebase._getAndStoreFCMToken(userData.userId, swRegistration);
    }

    async _initializePushNotifications() {
        const status = GENRALHELPERS._getPushNotificationStatus()

        if (status === 'permission needed') {
            this._CTANotificationsOn()
            return
        }

        if (status) {
            this._pushNotificationsActivate()
        }
    }

    /* ================================
       📱 NATIVE PUSH (Android / iOS)
       ================================ */
    async _initNativePush() {

        if (!window.Capacitor?.isNativePlatform?.()) return;

        // Prevent double init
        if (this.#nativeInitialized) return;
        this.#nativeInitialized = true;

        console.warn("📱 Native push init");

        try {
            const permStatus = await PushNotifications.requestPermissions();

            if (permStatus.receive !== 'granted') {
                console.warn('Push permission not granted');
                return;
            }

            await PushNotifications.register();

            // 🎟️ TOKEN
            PushNotifications.addListener('registration', async (token) => {
                console.log('📱 Native FCM Token:', token.value);

                await firebase._storeNativeFCMToken(token.value);
                console.log("📤 Native FCM token sent:", token.value);
            });

            // ❌ ERROR
            PushNotifications.addListener('registrationError', (err) => {
                console.error('Push registration error:', err);
            });

            // 📩 FOREGROUND
            PushNotifications.addListener('pushNotificationReceived', (notification) => {
                console.log('📩 Foreground push:', notification);
            });

            // 👆 TAP
            PushNotifications.addListener('pushNotificationActionPerformed', (notification) => {
                console.log('👆 Notification tapped:', notification);

                saved._openNotifications()
                nav._changeNav('Notification')

                const data = notification.notification?.data || {};

                if (data.url) {
                    openUrls._parseLocateAndDisplay(data.url);
                }
            });
        } catch (err) {
            console.error("Native push init error:", err);
        }
    }



}

export default new CTANotifications()